import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Sgke031aRequest, Sgke031aResponseCdtmnyInfo, Sgke031aResponseNrcptInfo, Sgke032aRequest, Sgke032aRequestCdtmnyInfo } from 'sg-api';
import { UsedSgke031aService } from '../../services/used-sgke031a.service';
import { UsedSgke032aService } from '../../services/used-sgke032a.service';

@Component({
  selector: 'app-sgke030d-view',
  templateUrl: './sgke030d-view.component.html',
  styleUrl: './sgke030d-view.component.scss'
})
export class Sgke030dViewComponent implements OnInit, OnDestroy {
  /** 請求お客さま番号（支払契約番号） */
  @Input() recptFixNo: string;
  /** 未精算金管理番号 */
  @Input() kinkoMno: string;
  /** 未精算金履歴番号 */
  @Input() kinkoRrkno: string;
  /** 未精算金_更新通番号 */
  @Input() kinkoUpdateSrno: string;
  /** 未精算金EX_更新通番号 */
  @Input() kinkoexUpdatesequencenumber: string;
  /** 今回入金額（未精算金残高金額） */
  @Input() remny: number;
  /** 領収情報番号（入金番号） */
  @Input() receiveMoneyNo: string;

  /** メッセージエミッター */
  @Output() msgEmit = new EventEmitter();
  /** 通常メッセージエミッター */
  @Output() normalMessageEmit = new EventEmitter();
  /** 警告メッセージエミッター */
  @Output() warningMessageEmit = new EventEmitter();
  /** エラーメッセージエミッター */
  @Output() errorMessageEmit = new EventEmitter();
  /** メッセージエリアクリアエミッター */
  @Output() clearMessageEmit = new EventEmitter();
  /** SGKE020D再描画（再検索）エミッター */
  @Output() searchEmit = new EventEmitter();

  /** 検索結果リスト */
  searchResultList: Array<Sgke031aResponseNrcptInfo> = new Array<Sgke031aResponseNrcptInfo>();

  /** SGKE031A_入金消込受付初期表示API_リクエスト */
  private request031a: Sgke031aRequest;
  /** SGKE032A_入金消込受付登録APIリクエスト */
  private request032a: Sgke032aRequest;

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  /**
   * コンストラクタ
   * @param {UsedSgke031aService} searchService
   * @param {UsedSgke032aService} registService
   * @param {ChangeDetectorRef} cd
   * @memberof Sgke030dSearchResultComponent
   */
  constructor(
    public searchService: UsedSgke031aService,
    public registService: UsedSgke032aService,
  ) { }

  /**
   * 初期処理
   * @memberof Sgke030dSearchResultComponent
   */
  ngOnInit(): void {
    // 初期表示
    this.init();
  }

  /**
   * 終了処理
   * @memberof Sgke030dSearchResultComponent
   */
  ngOnDestroy() {
    this.onDestroy$.next();
  }


  /**
   * 初期処理
   * @memberof Sgke030dSearchResultComponent
   */
  init() {

    // リクエスト情報をもつオブジェクトを定義
    this.request031a = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      initIndicateConditionInfo: {
        recptFixNo: this.recptFixNo,
      },
    };

    this.searchService.doSgke031a(this.request031a)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        response => {
          if (response) {
            // メッセージを表示
            if (response?.responseCommon?.errors?.length > 0) {
              this.msgEmit.emit(response?.responseCommon?.errors);
            }
            this.searchResultList = response.nrcptInfo;
          }
        },
        error => {
        }
      );
  }

  /**
   * 登録ボタン押下時
   *
   * @memberof Sgke030dSearchResultComponent
   */
  onClickRegist(row: Sgke031aResponseNrcptInfo): void {

    this.clearMessageEmit.emit();

    // オブジェクト生成関数
    let cdtmnyInfoFunc = function (row: Sgke031aResponseCdtmnyInfo): Sgke032aRequestCdtmnyInfo {
      return {
        cdtmnyNo: row.cdtmnyNo,
        cdtmnyRrkno: row.cdtmnyRrkno
      };
    }

    // リクエスト情報をもつオブジェクトを定義
    this.request032a = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      clmtoInfo: {
        recptFixNo: this.recptFixNo,
        hakkoYmt: row[0]?.hakkoYmt,
        claimChargeNo: row[0]?.claimChargeNo,
        cdtmnyInfo: row[0]?.cdtmnyInfo.map(cdtmnyInfoFunc)
      },
      miseisanInfo: {
        kinkoMno: this.kinkoMno,
        kinkoRrkno: this.kinkoRrkno,
        updateSrno: this.kinkoUpdateSrno,
        thistimeRcvmnyAmt: this.remny,
      }
    }

    this.registService.doSgke032a(this.request032a)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        response => {
          if (response) {
            this.searchEmit.emit(response?.miseisanInfo);
            // メッセージを表示
            if (response?.responseCommon?.errors?.length > 0) {
              this.msgEmit.emit(response?.responseCommon?.errors);
            }
          }
        },
        error => {
        }
      );
  }

}
